<app-modal
  [isActive]="isActive"
  [isLarge]="true"
  [showCloseFooter]="false"
  (modalState)="ValidateNeedRemark()"
>
  <p class="modal-card-title" modal-title>
    <span class="is-capitalized"> {{ 'itinerary-info.void-transaction.title' | translate }} </span>
  </p>

  <div modal-content>
    <div *ngIf="(state$ | async).currentProccess === vtStates.success">
      <app-alert type="success" class="message-separator">
        <span title> {{ 'shared.continue' | translate }} </span>
        <span description> {{ 'shared.successful-operation' | translate }} </span>
      </app-alert>
    </div>

    <div *ngIf="(state$ | async).currentProccess === vtStates.error">
      <app-alert type="error" class="message-separator">
        <span title>{{ 'shared.error' | translate }}</span>
        <span description> {{ (state$ | async).error.message }} </span>
      </app-alert>
    </div>

    <div
      *ngIf="
        (state$ | async).currentProccess === vtStates.initial ||
        (state$ | async).currentProccess === vtStates.makingQuery
      "
    >
      {{ 'itinerary-info.void-transaction.description' | translate }}
    </div>
  </div>

  <div modal-footer>
    <div class="buttons-container">
      <div *ngIf="(state$ | async).currentProccess === vtStates.success" class="button-remark">
        <app-remarks [isMarginTop]="false"></app-remarks>
      </div>

      <div class="button-change">
        <app-input-submit
          inputText="{{ 'voluntary-change.make-change' | translate }}"
          type="submit"
          [disabled]="
            (state$ | async).currentProccess == vtStates.makingQuery ||
            (state$ | async).currentProccess == vtStates.success
          "
          (clickButton)="applyVoidTransaction()"
        ></app-input-submit>
      </div>
    </div>
  </div>
</app-modal>

<app-modal
  [showCloseFooter]="false"
  [isActive]="showModalRemarks"
  (modalState)="showModalRemarks = false"
  [enableFooter]="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'shared.warning' | translate }}
  </p>
  <div modal-content>
    <p class="has-text-grey mb-2">
      {{ 'remarks.modal-remarks' | translate }}
    </p>
  </div>
</app-modal>
